module.exports = __webpack_public_path__ + "h5/img/Yuan.f2f204d8.jpg";